import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { checkAuthState } from "../../authentication/auth-utils/auth-utils";
import BidsList from "./bid-list/bids-list";
import BidsAdd from "./bid-add/bids-add";

const BidsContainer = () => {
    const navigate = useNavigate();
    const [isAuthorized, setIsAuthorized] = useState(null);

    useEffect(() => {
        checkAuthState((isLoggedIn) => {
          setIsAuthorized(isLoggedIn);
        });
    }, []);

    useEffect(() => {
        if (isAuthorized === false) {
          navigate('/');
        }
    }, [isAuthorized, navigate]);
    
    return (
        <>
            <div style={{ padding: 20 }}>
                <BidsList/>
                <BidsAdd/>
            </div>
        </>
    )
};

export default BidsContainer;